import React, { useEffect, useState } from "react";
import logo from "../assets/img/logo.svg";
import prev_arrow from "../assets/img/prev_arrow.svg";
import next_arrow from "../assets/img/next_arrow.svg";

const Step2 = ({ setStep, setFormdata, formData, setStep2Status}) => {
  const [firstNameError, setFirstNameError] = useState(false); // First name error state
  const [lastNameError, setLastNameError] = useState(false); // Last name error state

  // Handle Next button click
  const handleNext = () => {
    const firstName = formData?.name?.split(" ")[0] || "";
    const lastName = formData?.name?.split(" ")[1] || "";

    // Set individual errors
    setFirstNameError(!firstName);
    setLastNameError(!lastName);

    if (firstName && lastName) {
      setStep(3); // Proceed to the next step if both fields are filled
      setStep2Status(true)
    }
  };

  // useEffect(()=>{
  //   setFormdata((prevState) => ({
  //     ...prevState,
  //     name: null, // Update the first name and keep the last name
  //   }));
  // },[])

  return (
    <>
        
        <div class="top_logo_block">
          <div class="logo">
            <a href="">
              <img src={logo} alt="Logo" />
            </a>
          </div>
        </div>

        <div key={formData} class="step_body">
          <div class="step_form">
            <div class="form_block box_width_md_one">
              <h1>Awesome!</h1>
              <h2>Let’s get to know you</h2>
              <div class="input_fields">
                <input
                  type="text"
                  placeholder="First Name"
                  value={formData?.name?.split(" ")[0] || ""}
                  onChange={(e) => {
                    const lastName = formData?.name?.split(" ")[1] || ""; // Keep the last name the same
                    setFormdata((prevState) => ({
                      ...prevState,
                      name: `${e.target.value} ${lastName}`.trim(), // Update the first name and keep the last name
                    }));
                    setFirstNameError(false); // Clear first name error on input change
                  }}
                />
                {firstNameError && (
                  <p style={{ color: "red" }}>First name is required.</p>
                )}

                <input
                  type="text"
                  placeholder="Last Name"
                  value={formData?.name?.split(" ")[1] || ""}
                  onChange={(e) => {
                    const firstName = formData?.name?.split(" ")[0] || ""; // Keep the first name the same
                    setFormdata((prevState) => ({
                      ...prevState,
                      name: `${firstName} ${e.target.value}`.trim(), // Update the last name and keep the first name
                    }));
                    setLastNameError(false); // Clear last name error on input change
                  }}
                />
                {lastNameError && (
                  <p style={{ color: "red" }}>Last name is required.</p>
                )}
              </div>
            </div>
            <div class="btn_block">
              <a onClick={() => {
                setStep(1)
                }}>
                <img src={prev_arrow} alt="Previous" /> <span>Prev</span>
              </a>
              <a onClick={handleNext} class="nxt_btn">
                <span>Next</span> <img src={next_arrow} alt="Next" />
              </a>
            </div>
          </div>
        </div>


    </>
  );
};

export default Step2;